import React, { useEffect, useState } from "react";
import styles from "./_css/inputSearch.module.css";
import clsx from "clsx";
import search from "../../../assets/images/search.svg";
import { IconComponent } from "components/base/icon/IconComponent";

export type TInputProps<T = string> = React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
> & {
    onValueChange?: (value: T, event?: React.ChangeEvent<HTMLInputElement>) => void;
    isHomePage?: boolean;
    onClickOnSearchIcon?: () => void;
};

/* eslint-disable react/prop-types */
export const InputSearch = React.forwardRef<HTMLInputElement, TInputProps>(
    ({ className, onValueChange, onChange, onClickOnSearchIcon, isHomePage, ...props }, ref) => {
        const [isColored, setIsColored] = useState(false);

        useEffect(() => {
            setTimeout(() => {
                setIsColored(true);
            }, 500);
        }, []);
        return (
            <>
                {isHomePage ? (
                    <div className={"flex_row_center"}>
                        <input
                            {...props}
                            className={clsx(styles.input, "text_big")}
                            ref={ref}
                            onChange={(event) => {
                                if (onChange) onChange(event);
                                if (onValueChange) onValueChange(event.target.value);
                            }}
                        />
                        <div
                            className={clsx(styles.searchBtn, "flex_center_center cursor_pointer", {
                                [styles.searchBtnColored]: isColored,
                            })}
                        >
                            <IconComponent
                                className={styles.icon}
                                fontSize="large"
                                icon={"search"}
                                onClick={() => {
                                    if (onClickOnSearchIcon) onClickOnSearchIcon();
                                }}
                            />
                        </div>
                    </div>
                ) : (
                    <div className={clsx(styles.container, "flex_row_center")}>
                        <input
                            {...props}
                            className={clsx(styles.input, styles.primary)}
                            ref={ref}
                            onChange={(event) => {
                                if (onChange) onChange(event);
                                if (onValueChange) onValueChange(event.target.value);
                            }}
                        />
                        <img src={search} alt={"search"} className={styles.searchIcon} />
                    </div>
                )}
            </>
        );
    },
);
